<div class="container">

  <!-- ========================= -->
  <!-- INTERNATIONAL CERTIFICATES -->
  <!-- ========================= -->
  <div class="guideline-card">

    <h1>International Digital Certificates – PKCS#11 Compatible</h1>

    <h2>Step 1: Install the Certificate Driver</h2>
    <p>
      Please follow the installation guidelines provided by your certificate
      authority to download and install the required certificate driver.
    </p>

    <h2>Step 2: Download the QRTrustSign Setup</h2>

    <div class="download-section">
      <p>Click the button below to download the setup package.</p>
      <button class="download-btn" (click)="downloadInternationalZip()">
        Download Driver (ZIP)
      </button>
    </div>

    <h2>Step 3: Extract and Place the Files</h2>
    <ul>
      <li>Locate the downloaded ZIP file.</li>
      <li>Right-click and select <strong>Extract All</strong>.</li>
      <li>Move the extracted folder to a local directory.</li>
    </ul>

    <div class="warning">
      ⚠️ The folder must not be placed in OneDrive or any cloud-synchronized location.
    </div>

    <h2>Step 4: Run the Installation</h2>
    <ul>
      <li>Open the extracted folder.</li>
      <li>Locate the <strong>QRTrustSign</strong> batch file.</li>
      <li>Right-click → <strong>Run as Administrator</strong>.</li>
      <li>Select your preferred language.</li>
      <li>If prompted about a previous version, select <strong>No</strong>.</li>
      <li>Installation completes automatically.</li>
      <li>Press any key to close the command window.</li>
    </ul>

    <h2>Step 5: Configure the PKCS#11 Driver Path</h2>
    <ul>
      <li>Locate the <strong>QROWNTECH-pkcs11</strong> configuration file.</li>
      <li>Right-click → <strong>Edit with Notepad</strong>.</li>
      <li>Ensure the correct path to the certificate driver is defined.</li>
    </ul>

    <img class="screenshot" src="/assets/images/screenshot.jpg" alt="PKCS11 Example" />
  </div>

  <!-- ========================= -->
  <!-- EGYPT TRUST PROVIDER -->
  <!-- ========================= -->
  <div class="guideline-card">

    <div class="image-box-logo">
      <img width="300" src="/assets/custom-img/dashboardlogo.svg" />
    </div>

    <h1>Egypt Trust Provider – ePass2003 Driver Setup on Windows</h1>

    <p>
      To enable digital signing using a local token connected to your device,
      please follow the steps below.
    </p>

    <h2>Step 1: Download the ePass2003 Driver Setup</h2>

    <div class="download-section">
      <p>Click the button below to download the driver setup package.</p>
      <button class="download-btn" (click)="downloadEgyptTrustZip()">
        Download Driver (ZIP)
      </button>
    </div>

    <h2>Step 2: Extract and Place the Files</h2>
    <ul>
      <li>Locate the downloaded ZIP file.</li>
      <li>Right-click and select <strong>Extract All</strong>.</li>
      <li>Move the extracted folder to a local directory.</li>
    </ul>

    <div class="warning">
      ⚠️ The folder must not be placed in OneDrive or any cloud-synchronized location.
    </div>

    <h2>Step 3: Run the Installation</h2>
    <ul>
      <li>Open the extracted folder.</li>
      <li>Locate the <strong>QRTrustSign</strong> batch file.</li>
      <li>Right-click → <strong>Run as Administrator</strong>.</li>
      <li>Select your preferred language.</li>
      <li>If prompted about a previous version, select <strong>No</strong>.</li>
      <li>Installation completes automatically.</li>
      <li>Press any key to close the command window.</li>
    </ul>
  </div>

  <!-- ========================= -->
  <!-- UNINSTALL / UPDATE -->
  <!-- ========================= -->
  <div class="guideline-card">

    <h1>Uninstallation </h1>
    <p>To uninstall, please follow the steps below:</p>
    <ul>
      <li>Locate the <strong>UninstallQRTrustSign</strong> batch file.</li>
      <li>Right-click the file and select <strong>Run as Administrator</strong>.</li>
      <li>A command window will open and start the uninstallation process.</li>
      <li>The uninstallation will complete automatically.</li>
      <li>Press any key to close the command window once the process finishes.</li>
    </ul>

    <h1>Updating QRTrustSign JAR Version</h1>
    <p>If a new QRTrustSign JAR version is available and needs to be replaced:</p>
    <ul>
      <li>Run <strong>StopQRTrustSign</strong> as Administrator to stop the service.</li>
      <li>Replace the existing JAR file with the new version.</li>
      <li>Run <strong>StartQRTrustSign</strong> as Administrator to start the service again.</li>
    </ul>

  </div>

  <!-- ========================= -->
  <!-- SIGNING FLOW -->
  <!-- ========================= -->
  <div class="guideline-card">

    <h1>After Installation – Signing Flow</h1>

    <p>
      Before signing any document, insert the USB token and wait until the
      <strong>Digital Certificate</strong> button is highlighted in green.
    </p>

  <div class="image-box">
    <img
      src="/assets/images/digital-certificate.png"
      alt="Digital Certificate Button Highlighted"
    />
  </div>

    <div class="info">
      <p>Once enabled, you can sign documents using your digital certificate.</p>
      <p>
        If the token is not detected, the document will be signed using an
        <strong>advanced signature</strong>, which has lower legal enforceability.
      </p>
    </div>

  </div>

</div>
